export const OFFER_IMPORT_MAX_FILE_SIZE_KB = 1024
export const OFFER_IMPORT_FILE_SIZE_ERROR = 'The uploaded file must not exceed 1 MB.'
